import * as React from "react";
import { all, create } from "mathjs/lib/esm/number";
import { TableColum } from "../interfaces";
import { IDispatcher } from "../../../helpers/Dispatcher";
import { cn, createCounterMessage } from "../../../helpers/Utils";

import {
	File,
	Select,
	TextBox,
	TextArea,
	Telephone,
	TextMask,
	TextNumber,
	ProxyCalendar,
	SingleCheckBox,
	CheckBoxSet,
	RadioButtons,
	Description,
	ConstLink,
} from "../GridComponents";

interface ProxyFieldsProps {
	api: unknown;
	dispatcher: IDispatcher;
	disabled?: boolean;
	keyRow: string | number;
	keyCol: string | number;
	column: TableColum;
	columns: any;
	inputRef: Record<string | number, object>;
	setInputRef: any;
	fieldsRef: any;
	tableSchema?: any;
	error?: string | undefined;
}

const Fields = {
	File,
	Select,
	ConstLink,
	TextBox,
	TextArea,
	Telephone,
	TextMask,
	Number: TextNumber,
	Float: TextNumber,
	CheckBoxSet,
	CheckBox: SingleCheckBox,
	RadioButton: RadioButtons,
	Calendar: ProxyCalendar,
	RangedMultiCalendar: ProxyCalendar,
};

const ProxyFields = ({
	api,
	tableSchema,
	dispatcher,
	disabled,
	keyCol,
	keyRow,
	column,
	columns,
	inputRef,
	setInputRef,
	error = undefined,
}: ProxyFieldsProps) => {
	// TODO: После обновления версии реакт-тс - удалить @ts-ignore!!!
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	const Component = Fields?.[column?.type] || Fields.TextBox;

	const handleChange = (_value) => {
		const newValue = {
			...inputRef,
			[keyCol]: _value,
		};

		// calc math
		let needAMath = null;
		for (const index in columns) {
			if (columns[index].valueFromField) {
				needAMath = columns[index];
			}
		}
		if (needAMath) {
			const sourceData = Object.keys(needAMath.valueFromField.from).reduce((acc, key) => {
				const item = needAMath.valueFromField.from[key];
				if (newValue?.[item.field]) {
					return {
						...acc,
						[item.field]: newValue[item.field],
					};
				}
				return undefined;
			}, {});

			const math = create(all);
			try {
				const result = `${math.evaluate(needAMath.valueFromField.result, sourceData)}`;
				// @ts-ignore
				newValue?.[needAMath.field] = result;
			} catch (error) {
				console.error(error);
			}
		}
		setInputRef(newValue, columns);
	};

	return (
		<>
			<Description
				field={column?.field}
				extra={column?.extra}
				description={column?.description}
				notification={column?.notification}
				classNames={cn(`${column?.type}`, {
					"is-error": !!error,
				})}
			>
				<Component
					api={api}
					dispatcher={dispatcher}
					keyRow={keyRow}
					column={column}
					value={inputRef?.[keyCol]}
					handleChange={handleChange}
					disabled={column?.editable === false || column?.disabled || !!disabled}
					tableSchema={tableSchema}
				/>
			</Description>
			{!!error && <span className="label label-danger">{error}</span>}
			{column?.maxLength && (column?.maxLength > 0 || column?.minLength > 0) && (
				<div className="input-counter">
					{createCounterMessage(inputRef?.[keyCol], column?.maxLength, column?.minLength)}
				</div>
			)}
		</>
	);
};

export { ProxyFields };
